/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { AuthRoutes } from './route';

const LoginRoutes = () => {
  const menu = AuthRoutes.map((route, index) => {
    const { path, exact, name, component } = route;
    if (component) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        // <Route key={index} path={path} exact={exact} name={name} render={(props) => <route.component {...props} />} />
        <Route
          key={index}
          path={path}
          exact={exact}
          name={name}
          element={<route.component />}
        />
      );
    }

    return null;
  });

  return <Routes>{menu}</Routes>;
};

export default LoginRoutes;
